<app-main-table
  [apiService]="apiAdminService"
  [columns]="columns"
  [pluralEntityName]="'administradores'"
  [additionalMainActions]="additionalMainActions"
  (onMainAction)="mainActions($event)"
  [actions]="actions"
  (onAction)="actionMethods($event)"
></app-main-table>
<p-toast></p-toast>
<!-- `baseZIndex` alto porque esta confirmación se dispara con el modal de edición ABIERTO y tiene que
     quedar encima. Es el mismo remedio que usa wallet-config-list, el otro lugar del panel donde
     conviven p-dialog y p-confirmDialog. -->
<p-confirmDialog header="Confirmación" acceptLabel="Sí" rejectLabel="Cancelar" [baseZIndex]="10000" defaultFocus="reject"></p-confirmDialog>
<!--Form to create or update a admin-->
<p-dialog [(visible)]="createEntity" [style]="{ width: '450px' }" [header]="adminService.formMethod === 'CREATE' ? 'Nuevo administrador' : 'Actualizar administrador'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-admin-form></app-admin-form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!adminService.entity.valid"></button>
  </ng-template>
</p-dialog>
<!--End of form to create or update a admin-->